"use client";

import { createContext, useContext } from "react";

export interface ChatConfigContextValue {
  chatId: string;
  size: "sm" | "lg";
  showSuggestions: boolean;
  onMinimize?: () => void;
  onClose?: () => void;
}

export const ChatConfigContext = createContext<ChatConfigContextValue | null>(
  null,
);

export function useChatConfigContext(): ChatConfigContextValue {
  const context = useContext(ChatConfigContext);
  if (!context) {
    throw new Error(
      "useChatConfigContext must be used within a ChatConfigProvider",
    );
  }
  return context;
}

export function useChatConfigContextOptional(): ChatConfigContextValue | null {
  return useContext(ChatConfigContext);
}
